import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, FormattedNumber, defineMessages, injectIntl } from 'react-intl'
import $ from 'jquery'
import { DEPOSIT_TYPE } from '../state/pricing/DepositTypes'
import FormattedInputField from "../sharedComponents/formattedInputField.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";

const messages = defineMessages({
    [DEPOSIT_TYPE.FLAT_DEPOSIT]: {
        id: "quote.deposit.flat_deposit",
        defaultMessage: "Flat Deposit",
    },
    [DEPOSIT_TYPE.PERCENTAGE_DEPOSIT]: {
        id: "quote.deposit.percentage_deposit",
        defaultMessage: "Percentage Deposit",
    },
})

class DepositQuote extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            depositRatio: this.props.depositRatio && this.props.depositType == DEPOSIT_TYPE.PERCENTAGE_DEPOSIT ? this.props.depositRatio * 100 : '',
            depositType: this.props.depositType,
            selectedOptionKey: this.props.depositType || DEPOSIT_TYPE.PERCENTAGE_DEPOSIT,
            depositAmount: this.props.depositAmount !== '0.00' && this.props.depositType == DEPOSIT_TYPE.FLAT_DEPOSIT ? this.props.depositAmount : '',
            currency: this.props.currency,
            totalAmount: this.props.totalAmount,
            endPoint: this.getEndPoint(this.props),
            fees: [],
            disabled: false,
        }

        this.selectOptions = {
            [DEPOSIT_TYPE.FLAT_DEPOSIT]: this.props.currency,
            [DEPOSIT_TYPE.PERCENTAGE_DEPOSIT]: "%"
        };

        this.onClose = this.props.onClose
        this.handleUnitSelection = this.handleUnitSelection.bind(this)
        this.handleRatioChange = this.handleRatioChange.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.applyFee = this.applyFee.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }

    getEndPoint(props) {
        if (props.mainObject && props.objectId) {
            return '/' + props.mainObject + '/' + props.objectId
        }
        return props.invoiceId ? '/invoices/' + props.invoiceId : '/quotes/' + props.quoteId
    }

    applyFee(event) {
        let data = {
            "depositType": this.state.selectedOptionKey
        }
        if (this.state.depositAmount !== '') {
            data.depositAmount = this.state.depositAmount
        } else if (this.state.depositRatio !== '') {
            data.depositRatio = this.state.depositRatio / 100
        } else {
            data.depositRatio = 0
        }
        AppContext.getApiClient().patch(this.state.endPoint, data).then(_ => this.closeModals(event))
    }

    handleRatioChange(event) {
        const target = event.target;
        this.setState({
            depositRatio: target.value
        });
    }

    handleUnitSelection(event) {
        const target = event.target;
        this.setState({
            selectedOptionKey: target.value
        })
    }

    componentDidMount() {
        let state = {}
        if (parseFloat(this.state.depositRatio) > 0) {
            state.depositRatio = this.state.depositRatio
            state.depositAmount = ''
            this.setState(state)
        } else if (this.state.depositAmount !== '') {
            state.depositAmount = this.state.depositAmount
            state.depositRatio = ''
            this.setState(state)
        }
        $('#depositModal').modal('show')
    }

    calculateDepositRatio(amount) {
        return this.numberFormat(parseFloat(amount) / parseFloat(this.state.totalAmount) * 100)
    }

    calculateDepositAmount(ratio) {
        return this.numberFormat(ratio / 100 * this.state.totalAmount)
    }

    closeModals(event) {
        event.preventDefault()
        $('#depositModal').modal('hide')
        this.onClose()
    }

    handleFocus(event) {
        event.target.select()
    }

    numberFormat(num) {
        if (isNaN(num)) {
            return GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())
        }
        return Math.round(num * 100) / 100
    }

    render() {
        return (
            <div>
                <div className="modal fade"
                    id="depositModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <FormattedMessage
                                        id="quote.set_deposit_modal.title"
                                        defaultMessage="Deposit"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="form-inline d-flex justify-content-center">
                                        <div className="input-group mb-3 ml-3">
                                            <FormattedInputField
                                                type="text"
                                                className="form-control"
                                                valueType="decimal"
                                                allowNegative={false}
                                                onFocus={this.handleFocus}
                                                placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                                                value={this.state.selectedOptionKey == DEPOSIT_TYPE.FLAT_DEPOSIT ? this.state.depositAmount : this.state.depositRatio}
                                                onValueChange={(newValue) => {
                                                    let depositAmount = ''
                                                    let depositRatio = ''
                                                    if (this.state.selectedOptionKey != DEPOSIT_TYPE.FLAT_DEPOSIT) {
                                                        depositRatio = newValue
                                                    } else {
                                                        depositAmount = newValue
                                                    }
                                                    this.setState({
                                                        depositAmount: depositAmount,
                                                        depositRatio: depositRatio,
                                                    })
                                                }}
                                            />
                                            <select value={this.state.selectedOptionKey} className="custom-select col-4" id="dropDownDiscountUnit" required onChange={this.handleUnitSelection} disabled={false}>
                                                {Object.entries(this.selectOptions).map(([key, value]) => <option key={key} id={key} value={key}>{value}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.set_deposit_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <button type="button" className="btn btn-primary" onClick={this.applyFee}>
                                    <FormattedMessage
                                        id="quote.set_deposit_modal.apply_deposit_btn"
                                        defaultMessage="Apply Deposit"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(DepositQuote)





// WEBPACK FOOTER //
// ./src/quote/deposit.component.jsx